export default __webpack_public_path__ + "static/media/login.56fbc64d.gif";